@if (tocContent.length) {
  <div class="toc" #tocRootElement>
    <div class="toc-title">{{ 'Table of contents'|translate }}</div>
    <div class="toc-container" [class.toc-container-two]="hasTwoColumns">
      <ul class="toc-list">
        @for (item of tocContent; track item.id; let last = $last) {
          <li>
            <span
              #isOverflow="textOverflowY"
              [matTooltipDisabled]="!isOverflow.value"
              [matTooltip]="item.text"
              matTooltipPosition="above"
              textOverflowY
              (click)="scrollToHeader(item.id)"
              class="toc-list-item">{{ item.text }}
            </span>
            @if (item.children.length) {
              <ul class="toc-list has-padding">
                @for (children of item.children; track children.id;
                  let first = $first;
                  let last = $last) {
                  <li
                    [class.is-first]="first"
                    [class.is-last]="last">
                    <span
                      #isOverflow="textOverflowY"
                      [matTooltipDisabled]="!isOverflow.value"
                      [matTooltip]="item.text"
                      matTooltipPosition="above"
                      textOverflowY
                      (click)="scrollToHeader(children.id)"
                      class="toc-list-item">{{ children.text }}
                    </span>
                  </li>
                }
              </ul>
            }

          </li>
        }
      </ul>
    </div>
  </div>
}
